<template>
	<div id="contexHeader" >
		<img id="fire"   style="width: 50px; height: 50px; " :src="require('@/assets/image/element/fire.png')">
		<div class="navi-item"  style="cursor:pointer;" v-for="item in firemenus" @click="intoMainList(item.blockId)">{{item.blockName}}</div>
	</div>
</template>

<script>
	import {
		getFireMenu
	} from '@/network/index.js';
	export default {
		name: "FireMenu",
		props: {

		},
		data() {
			return {
				firemenus: []
			}
		},
		created() {
			getFireMenu().then(res => {

					for (var i = 0; i < res.data.obj.length; i++) {

						this.firemenus.push({
							blockId: res.data.obj[i].id,
							blockName: res.data.obj[i].name
						});

					}

				})
				.catch(error => {});
		},
		computed: {

		},
		methods: {
			 
			intoMainList(value){
				 
				this.$router.push({
					path : '/',
					query: {
						//前面的searchValue可以随便取
						blockId: value,
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.navi-item {
		flex: 1; //等分
		text-align: center; //等分后居中
		height: 50px; //设置高度
		font-size: 25px; //设置字体大小
		color: #2d8cf0;
		
		position: relative;
		font-family: "PingFang SC";
		padding: 7px;
		padding-left: 25px;
	}
</style>
